import {
  DateRangePickerInput,
  type DateRangePickerInputProps,
} from "src/components/DateRangePickerInput/DateRangePickerInput.tsx";

import {
  Controller,
  type ControllerProps,
  type FieldPath,
  type FieldValues,
} from "react-hook-form";
import React from "react";
import { composeRefs } from "@exonn/hooks";
import { type Dayjs, default as dayjs } from "dayjs";

// type ValidValue = [string | null, string | null] | undefined;

export type DateRangeFieldProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = {
  name: TName;
} & Omit<DateRangePickerInputProps, "onChange"> & {
    onChange?: (value: any) => void;
  } & Omit<ControllerProps<TFieldValues, TName>, "render">;

// todo: forward ref
export const DateRangeField = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(
  props: DateRangeFieldProps<TFieldValues, TName>,
) => {
  const {
    name,
    disabled,
    control,
    rules,
    defaultValue,
    shouldUnregister,
    onChange: onChangeProp,
    ...restProps
  } = props;

  return (
    <Controller
      control={control}
      // disabled={disabled} // it is bad idea to disable controller, isDirty form state will be broken
      rules={rules}
      defaultValue={defaultValue}
      shouldUnregister={shouldUnregister}
      render={({
        field: { name, value, onChange, ref },
        formState: { errors },
      }) => {
        const value_ = [
          value?.[0] ? dayjs(value[0]) : null,
          value?.[1] ? dayjs(value[1]) : null,
        ] as [Dayjs | null, Dayjs | null];
        return (
          <DateRangePickerInput
            disabled={disabled}
            inputRef={composeRefs(ref)}
            name={name}
            value={value_}
            error={
              errors?.root?.[name]?.message // server error
            }
            onClear={() => {
              onChange([null, null]);
            }}
            onChange={(value) => {
              const nextValue: [string | null, string | null] = [
                value[0] ? value[0].format("YYYY-MM-DD HH:mm:ss") : null,
                value[1] ? value[1].format("YYYY-MM-DD HH:mm:ss") : null,
              ];
              onChange(nextValue);

              onChangeProp?.(nextValue);
            }}
            {...restProps}
          />
        );
      }}
      name={name}
    />
  );
};
